import { useLayoutEffect } from 'react';

// import { isProduction } from 'constants/env';

export const ScrollToTopOnMount = () => {
  useLayoutEffect(() => {
    // if (isProduction) {
    window.scrollTo(0, 0);
    // }
  }, []);

  return null;
};
